// centersData.js
import mekanissa1 from '../../../assets/images/icons/dmekanissa1.jpg';
import mekanissa2 from '../../../assets/images/icons/dmekanissa2.jpg';
import banner from '../../../assets/images/icons/mekanisa.jpg';
import adwabanner from '../../../assets/images/icons/City_of_Adwa.jpg';
import adwa from '../../../assets/images/icons/adwa.jpg';
import assosa from '../../../assets/images/icons/assossa.jpg';
import assosabanner from '../../../assets/images/icons/assosa.jpg';
import axum from '../../../assets/images/icons/axum.jpg';
import axumbanner from '../../../assets/images/icons/axumbanner.jfif';
import bahirdar from '../../../assets/images/icons/bahirdar.jpg';
import bahirdarBanner from '../../../assets/images/icons/bahirdarBanner.jpg';
import bishoftu from '../../../assets/images/icons/bishoftu.jpg';
import bishoftuBanner from '../../../assets/images/icons/bishoftubanner.jpg';
import debrebrihan from '../../../assets/images/icons/debrebrihan.jpg';
import debrebirhanBanner from '../../../assets/images/icons/debrebrihanbanner.jpg';
import dessie from '../../../assets/images/icons/dessie.jpg';
import dessieBanner from '../../../assets/images/icons/dessiebanner.jpg';
import harar from '../../../assets/images/icons/harar.jpg';
import hararBanner from '../../../assets/images/icons/hararbanner.jpg';
import hawassa from '../../../assets/images/icons/hawassa.jpg';
import hawassaBanner from '../../../assets/images/icons/hawassabanner.jpg';
import jigjiga from '../../../assets/images/icons/jigjiga.jpg';
import jigjigaBanner from '../../../assets/images/icons/jigjigabanner.jpg';
import jimma from '../../../assets/images/icons/jimma.jpg';
import jimmaBanner from '../../../assets/images/icons/jimmabanner.jpg';
import logia from '../../../assets/images/icons/logia.jpg';
import logiaBanner from '../../../assets/images/icons/logiabanner.jpg';
import dmekelle from '../../../assets/images/icons/dmekelle.jpg';
import dmekelleBanner from '../../../assets/images/icons/dmekellebanner.jpg';
import dmeskel from '../../../assets/images/icons/dmeskel.jpg';
import dmeskelBanner from '../../../assets/images/icons/dmeskelbanner.jpg';
import gondar from '../../../assets/images/icons/gondar.jpg';
import gondarBanner from '../../../assets/images/icons/gondarbanner.jpg';
import worota from '../../../assets/images/icons/woreta.jpg';
import worotaBanner from '../../../assets/images/icons/gondarbanner.jpg';
export const centersData = [
  {
    name: 'Main',
    bannerImage: banner,
    description: 'At Mekanissa Campus, we provide exceptional educational experiences.',
    deanMessage: 'Welcome to Mekanissa Campus! Our dedicated faculty are here to guide you.',
    deanImage: '../../../../assets/images/icons/meg1.jpg',
    deanName: 'Abrham G/Yohannes (PhD)',
    programs: [
    
		'Business Management', 'Agricultural Economics', 'Educational Planning and Management', 'Marketing Management', 'Economics', 'Rural Development & Agricultural Extension', 'Accounting and Finance'
    ],
    certifications: [
      { image: mekanissa1},
      { image: mekanissa2},
    ],
  },
  {
    name: 'Adwa',
    bannerImage: adwabanner,
    description: 'At Adwa Campus, we provide exceptional educational experiences.',
    deanMessage: 'Welcome to Adwa Campus! Our dedicated faculty are here to guide you.',
   
    programs: [
    
		'Business Management',  'Educational Planning and Management', 'Marketing Management', 'Economics',  'Accounting and Finance'
    ],
    certifications: [
      { image: adwa },
    
    ],
  },
	
  {
    name: 'Assosa',
    bannerImage: assosabanner,
    description: 'At Assosa Campus, we provide exceptional educational experiences.',
    deanMessage: 'Welcome to Assosa Campus! Our dedicated faculty are here to guide you.',
   
    programs: [
    
		'Business Management',  'Educational Planning and Management', 'Marketing Management', 'Economics',  'Accounting and Finance'
    ],
    certifications: [
      { image: assosa },
    
    ],
  },

   {
    name: 'Axum',
    bannerImage: axumbanner,
    description: 'At Axum Campus, we provide exceptional educational experiences.',
    deanMessage: 'Welcome to Axum Campus! Our dedicated faculty are here to guide you.',
   
    programs: [
    
		'Business Management',  'Educational Planning and Management', 'Marketing Management', 'Economics',  'Accounting and Finance'
    ],
    certifications: [
      { image: axum },
    
    ],
  },
	 {
    name: 'Bahirdar',
    bannerImage: bahirdarBanner,
    description: 'At Bahirdar Campus, we provide exceptional educational experiences.',
    deanMessage: 'Welcome to Bahirdar Campus! Our dedicated faculty are here to guide you.',
   
    programs: [
    
		'Business Management',  'Educational Planning and Management', 'Marketing Management', 'Economics',  'Accounting and Finance'
    ],
    certifications: [
      { image: bahirdar },
    
    ],
  },
	{
    name: 'Bishoftu',
    bannerImage: bishoftuBanner,
    description: 'At Bishoftu Campus, we provide exceptional educational experiences.',
    deanMessage: 'Welcome to Bishoftu Campus! Our dedicated faculty are here to guide you.',
   
    programs: [
    
		'Business Management',  'Educational Planning and Management', 'Marketing Management', 'Economics',  'Accounting and Finance'
    ],
    certifications: [
      { image: bishoftu},
    
    ],
  },
		{
    name: 'Debrebirhan',
    bannerImage: debrebirhanBanner,
    description: 'At Debrebirhan Campus, we provide exceptional educational experiences.',
    deanMessage: 'Welcome to Debrebirhan Campus! Our dedicated faculty are here to guide you.',
   
    programs: [
    
		'Business Management',  'Educational Planning and Management', 'Marketing Management', 'Economics',  'Accounting and Finance'
    ],
    certifications: [
      { image: debrebrihan},
    
    ],
  },
	{
    name: 'Dessie',
    bannerImage: dessieBanner,
    description: 'At Dessie Campus, we provide exceptional educational experiences.',
    deanMessage: 'Welcome to Dessie Campus! Our dedicated faculty are here to guide you.',
   
    programs: [
    
		'Business Management',  'Educational Planning and Management', 'Marketing Management', 'Economics',  'Accounting and Finance'
    ],
    certifications: [
      { image: dessie},
    
    ],
  },
	{
    name: 'Harar',
    bannerImage: hararBanner,
    description: 'At Harar Campus, we provide exceptional educational experiences.',
    deanMessage: 'Welcome to Harar Campus! Our dedicated faculty are here to guide you.',
   
    programs: [
    
		'Business Management',  'Educational Planning and Management', 'Marketing Management', 'Economics',  'Accounting and Finance'
    ],
    certifications: [
      { image: harar},
    
    ],
  },
	{
    name: 'Hawassa',
    bannerImage: hawassaBanner,
    description: 'At Hawassa Campus, we provide exceptional educational experiences.',
    deanMessage: 'Welcome to Hawassa Campus! Our dedicated faculty are here to guide you.',
   
    programs: [
    
		'Business Management',  'Educational Planning and Management', 'Marketing Management', 'Economics',  'Accounting and Finance'
    ],
    certifications: [
      { image: hawassa},
    
    ],
  },
	{
    name: 'Jigjiga',
    bannerImage: jigjigaBanner,
    description: 'At Jigjiga Campus, we provide exceptional educational experiences.',
    deanMessage: 'Welcome to Jigjiga Campus! Our dedicated faculty are here to guide you.',
   
    programs: [
    
		'Business Management',  'Educational Planning and Management', 'Marketing Management', 'Economics',  'Accounting and Finance'
    ],
    certifications: [
      { image: jigjiga},
    
    ],
  },
	
	{
    name: 'Jimma',
    bannerImage: jimmaBanner,
    description: 'At Jimma Campus, we provide exceptional educational experiences.',
    deanMessage: 'Welcome to Jimma Campus! Our dedicated faculty are here to guide you.',
   
    programs: [
    
		'Business Management',  'Educational Planning and Management', 'Marketing Management', 'Economics',  'Accounting and Finance'
    ],
    certifications: [
      { image: jimma},
    
    ],
  },
	{
    name: 'Logia',
    bannerImage: logiaBanner,
    description: 'At Logia Campus, we provide exceptional educational experiences.',
    deanMessage: 'Welcome to Logia Campus! Our dedicated faculty are here to guide you.',
   
    programs: [
    
		'Business Management',  'Educational Planning and Management', 'Marketing Management', 'Economics',  'Accounting and Finance'
    ],
    certifications: [
      { image: logia},
    
    ],
  },
	{
    name: 'Mekelle',
    bannerImage: dmekelleBanner,
    description: 'At Mekelle Campus, we provide exceptional educational experiences.',
    deanMessage: 'Welcome to Mekelle Campus! Our dedicated faculty are here to guide you.',
   
    programs: [
    
		'Business Management',  'Educational Planning and Management', 'Marketing Management', 'Economics',  'Accounting and Finance'
    ],
    certifications: [
      { image: dmekelle},
    
    ],
  },{
    name: 'gondar',
    bannerImage: gondarBanner,
    description: 'At Gondar Campus, we provide exceptional educational experiences.',
    deanMessage: 'Welcome to Gondar Campus! Our dedicated faculty are here to guide you.',
   
    programs: [
    
		'Business Management',  'Educational Planning and Management', 'Marketing Management', 'Economics',  'Accounting and Finance'
    ],
    certifications: [
      { image: gondar},
    
    ],
  },
	{
    name: 'worota',
    bannerImage: worotaBanner,
    description: 'At Wereta Campus, we provide exceptional educational experiences.',
    deanMessage: 'Welcome to Wereta Campus! Our dedicated faculty are here to guide you.',
   
    programs: [
    
		'Business Management',  'Educational Planning and Management', 'Marketing Management', 'Economics',  'Accounting and Finance'
    ],
    certifications: [
      { image: worota},
    
    ],
  },
	{
    name: 'Meskel-Square',
    bannerImage: dmeskelBanner,
    description: 'At Meskel-Square Campus, we provide exceptional educational experiences.',
    deanMessage: 'Welcome to Meskel-Square Campus! Our dedicated faculty are here to guide you.',
   
    programs: [
    
		'Business Management',  'Educational Planning and Management', 'Marketing Management', 'Economics',  'Accounting and Finance'
    ],
    certifications: [
      { image: dmeskel},
    
    ],
  },
];